<template>
  <div class="main-layout">
    <!-- 移动端菜单按钮 -->
    <div class="mobile-header" v-if="isMobile">
      <i class="el-icon-s-management"></i>
      <span class="mobile-title">投票管理系统</span>
      <i class="el-icon-menu menu-toggle" @click="toggleSidebar"></i>
    </div>

    <!-- 遮罩层 -->
    <div class="sidebar-overlay" v-if="isMobile && showSidebar" @click="closeSidebar"></div>

    <div class="sidebar" :class="{ 'mobile-sidebar': isMobile, 'show': showSidebar }">
      <div class="logo-area">
        <i class="el-icon-s-management"></i>
        <span class="logo-title">投票管理系统</span>
      </div>
      <div class="user-info">
        <el-avatar :size="40" :src="userInfo.avatar"></el-avatar>
        <span class="username">{{ displayName }}</span>
      </div>
      <el-menu
        :default-active="activeMenu"
        class="menu"
        background-color="#2c3e50"
        text-color="#ecf0f1"
        active-text-color="#3498db"
        router
        @select="handleMenuSelect">
        <el-menu-item index="/home/welcome">
          <i class="el-icon-s-home"></i>
          <span>首页</span>
        </el-menu-item>
        <el-menu-item index="/home/user">
          <i class="el-icon-user"></i>
          <span>用户管理</span>
        </el-menu-item>
        <el-menu-item index="/home/partner">
          <i class="el-icon-s-custom"></i>
          <span>合伙人管理</span>
        </el-menu-item>
        <el-menu-item index="/home/proposal">
          <i class="el-icon-document"></i>
          <span>议案管理</span>
        </el-menu-item>
        <el-menu-item index="/home/vote">
          <i class="el-icon-circle-check"></i>
          <span>投票任务管理</span>
        </el-menu-item>
        <el-menu-item index="/home/delegate">
          <i class="el-icon-s-order"></i>
          <span>委托管理</span>
        </el-menu-item>
        <el-menu-item @click="handleLogout" class="logout-item">
          <i class="el-icon-switch-button"></i>
          <span>退出登录</span>
        </el-menu-item>
      </el-menu>
    </div>
    <div class="main-content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MainLayout',
  data () {
    return {
      userInfo: {
        displayName: '',
        avatar: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'
      },
      activeMenu: '/home/welcome',
      isMobile: false,
      showSidebar: false
    }
  },
  computed: {
    displayName () {
      return this.$store.getters.displayName
    }
  },
  mounted () {
    this.checkMobile()
    this.updateActiveMenu()
    window.addEventListener('resize', this.checkMobile)
    this.$router.afterEach((to) => {
      this.updateActiveMenu()
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.checkMobile)
  },
  methods: {
    updateActiveMenu () {
      this.activeMenu = this.$route.path
    },
    checkMobile () {
      this.isMobile = window.innerWidth <= 768
      if (!this.isMobile) {
        this.showSidebar = false
      }
    },
    toggleSidebar () {
      this.showSidebar = !this.showSidebar
    },
    closeSidebar () {
      this.showSidebar = false
    },
    handleMenuSelect () {
      if (this.isMobile) {
        this.closeSidebar()
      }
    },
    handleLogout () {
      this.$store.dispatch('logout')
      // 可选：清除持久化的 Vuex 状态
      try { localStorage.removeItem('voting-manage') } catch (e) {}
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.main-layout {
  display: flex;
  height: 100vh;
}

.sidebar {
  width: 220px;
  background: linear-gradient(180deg, #2c3e50 0%, #34495e 100%);
  color: #fff;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);
}

.logo-area {
  padding: 25px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.1);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.logo-area i {
  font-size: 28px;
  color: #3498db;
  margin-right: 10px;
}

.logo-title {
  font-size: 18px;
  font-weight: bold;
  color: #ecf0f1;
  letter-spacing: 1px;
}

.user-info {
  padding: 20px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  background-color: rgba(0, 0, 0, 0.05);
}

.username {
  margin-left: 12px;
  font-size: 14px;
  color: #ecf0f1;
  font-weight: 500;
}

.menu {
  border-right: none;
}

.menu .el-menu-item,
.menu .el-submenu__title {
  text-align: left;
  padding-left: 20px !important;
}

.menu .el-menu-item {
  transition: all 0.3s;
}

.menu .el-menu-item:hover {
  background-color: rgba(52, 152, 219, 0.1) !important;
}

.menu .el-menu-item.is-active {
  background-color: rgba(52, 152, 219, 0.2) !important;
  border-left: 3px solid #3498db;
}

.menu .el-menu-item i {
  color: #ecf0f1;
  font-size: 16px;
}

.logout-item {
  margin-top: auto;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.logout-item:hover {
  background-color: rgba(231, 76, 60, 0.1) !important;
}

.main-content {
  flex: 1;
  padding: 20px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  overflow: auto;
}

/* 移动端样式 */
.mobile-header {
  display: none;
  height: 50px;
  background: linear-gradient(180deg, #2c3e50 0%, #34495e 100%);
  color: #fff;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1001;
}

.mobile-header i:first-child {
  font-size: 24px;
  color: #3498db;
}

.mobile-title {
  font-size: 16px;
  font-weight: bold;
  flex: 1;
  text-align: center;
}

.menu-toggle {
  font-size: 24px;
  cursor: pointer;
  padding: 5px;
}

.sidebar-overlay {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

@media screen and (max-width: 768px) {
  .mobile-header {
    display: flex;
  }

  .main-layout {
    padding-top: 50px;
  }

  .sidebar {
    position: fixed;
    top: 50px;
    left: -220px;
    bottom: 0;
    z-index: 1000;
    transition: left 0.3s ease;
  }

  .sidebar.show {
    left: 0;
  }

  .sidebar-overlay {
    display: block;
  }

  .main-content {
    padding: 15px 10px;
  }
}

@media screen and (max-width: 480px) {
  .main-content {
    padding: 10px 5px;
  }
}
</style>
